import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import styles from "../styles/Header.module.css";
import logo from "../assets/images/churchLogo.png";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  // Scroll detection effect
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      // Trigger immediately after any scroll
      const scrolled = scrollTop > 10;
      setIsScrolled(scrolled);
    };

    window.addEventListener('scroll', handleScroll);
    
    // Check initial scroll position
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMenuToggle = () => setMenuOpen(!menuOpen);
  const handleNavClick = () => setMenuOpen(false);

  const handleFellowshipClick = () => {
    navigate("/fellowship");
    setMenuOpen(false);
  };

  const handleGetStartedClick = () => {
    navigate("/login");
    setMenuOpen(false);
  };

  return (
    <>
      <header className={`${styles.header} ${isScrolled ? styles.headerScrolled : ''}`}>
        <div className={styles.container}>
          <div className={styles.headerContent}>
            {/* Logo */}
            <div className={styles.logo}>
              <img src={logo} alt="Church Logo" className={styles.logoImage} />
              <span className={styles.logoTextFull}>C.W.F.M</span>
              <span className={styles.logoTextShort}>CWF</span>
            </div>

            {/* Desktop Navigation */}
            <nav className={styles.navWrapper}>
              <ul className={styles.nav}>
                <li>
                  <Link to="/" className={styles.navLink}>
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about-us" className={styles.navLink}>
                    About
                  </Link>
                </li>
                 <li>
                  <Link to="/ministry" className={styles.navLink}>
                    Ministries
                  </Link>
                </li>
                 <li>
                  <Link to="/events" className={styles.navLink}>
                    Events
                  </Link>
                </li>
                <li>
                  <Link to="/sermons" className={styles.navLink}>
                    Sermons
                  </Link>
                </li>
               
               
              </ul>
            </nav>

            {/* Actions (Right Side) */}
            <div className={styles.actions}>
              <div className={styles.buttonGroup}>
                <button
                  className={styles.visitBtn}
                  onClick={handleFellowshipClick}
                >
                  FELLOWSHIP WITH US
                </button>
              </div>

              {/* Mobile Menu Button */}
              <button
                onClick={handleMenuToggle}
                className={styles.menuBtn}
                aria-label="Toggle menu"
              >
                {menuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {menuOpen && (
            <>
              <nav
                className={`${styles.mobileMenu} ${
                  menuOpen ? styles.mobileMenuOpen : ""
                }`}
              >
                <ul className={styles.mobileNav}>
                  <li>
                    <Link
                      to="/"
                      onClick={handleNavClick}
                      className={styles.mobileNavLink}
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about-us"
                      onClick={handleNavClick}
                      className={styles.mobileNavLink}
                    >
                      About
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/sermons"
                      onClick={handleNavClick}
                      className={styles.mobileNavLink}
                    >
                      Sermons
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/ministry"
                      onClick={handleNavClick}
                      className={styles.mobileNavLink}
                    >
                      Ministries
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/events"
                      onClick={handleNavClick}
                      className={styles.mobileNavLink}
                    >
                      Events
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/involved"
                      onClick={handleNavClick}
                      className={styles.mobileNavLink}
                    >
                      Get Involved
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/give"
                      onClick={handleNavClick}
                      className={styles.mobileNavLink}
                    >
                      Give
                    </Link>
                  </li>
                </ul>

                <div className={styles.mobileButtonGroup}>
                  <button
                    className={styles.mobileVisitBtn}
                    onClick={handleFellowshipClick}
                  >
                    FELLOWSHIP WITH US
                  </button>

                  <button
                    className={styles.mobileGetStartedBtn}
                    onClick={handleGetStartedClick}
                  >
                    GET STARTED
                  </button>
                </div>
              </nav>

              <div className={styles.overlay} onClick={handleNavClick} />
            </>
          )}
        </div>
      </header>

      {/* Spacer for fixed header */}
      <div className={styles.spacer} />
    </>
  );
}